import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import Shimmer from "components/ui/shimmer"
import { isTestMode } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"
import { cn } from "styles/utils"

const InternalBreadcrumb = ({ breadcrumb_array, wizardLoading }) => {
  const { isMobile } = useWindowDimensions()

  const handleBreadcrumbClick = () => {
    if (!isTestMode && isMobile) {
      dataLayer.push({
        event: "clicked-breadcrumbs-pdp",
      })
    }
  }
  if (wizardLoading) {
    return <Shimmer className="mb-8 h-14" style={{ width: "160px" }} />
  }
  return (
    <nav aria-label="Breadcrumb" className="mb-8">
      <ol className="text-grey-400 text-12 leading-14 list-none font-medium">
        {breadcrumb_array.map((breadcrumb, i) => (
          <li
            className={cn(
              "inline",
              i > 0 && "before:px-4 before:content-['/']"
            )}
            key={`breadcrumb-${breadcrumb.name}`}
          >
            <Link
              data-lc="breadcrumb"
              onClick={handleBreadcrumbClick}
              to={breadcrumb.url}
            >
              {breadcrumb.name}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  )
}

const mapStateToProps = (state) => {
  return {
    breadcrumb_array: state.wizard.description.breadcrumb || [],
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => ({})

InternalBreadcrumb.propTypes = {
  breadcrumb_array: PropTypes.array,
  wizardLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

const Breadcrumb = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalBreadcrumb)

export default Breadcrumb
